import { render, staticRenderFns } from "./StoryPublishDialog.vue?vue&type=template&id=bfe50b20&scoped=true&"
import script from "./StoryPublishDialog.vue?vue&type=script&lang=js&"
export * from "./StoryPublishDialog.vue?vue&type=script&lang=js&"
import style0 from "./StoryPublishDialog.vue?vue&type=style&index=0&id=bfe50b20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe50b20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VAlert,VBtn,VDialog})
